import React, { useState, useEffect } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'

import Toggle from '../../atoms/Dropdown/Toggle'
import Menu from '../../atoms/Dropdown/Menu'
import Container from '../../atoms/Dropdown/Container'

export default ({ className, selected, children, direction, ...toggle }) => {
  const [show, setShow] = useState()

  useEffect(() => {
    setShow(false)
  }, [selected])

  return (
    <Container show={show} direction={direction} className={className}>
      <OutsideClickHandler onOutsideClick={() => setShow(false)}>
        <Toggle onClick={() => setShow(!show)} {...toggle}>
          {selected}
        </Toggle>
      </OutsideClickHandler>
      <Menu>{children}</Menu>
    </Container>
  )
}
